/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import EditInputHeader from 'app/components/Headers/EditInputHeader.jsx';
import ButtonList from 'app/components/common/ButtonList.jsx';
import InputEditorButtons from 'app/mixins/InputEditorButtonsMixin.js';
import InputFieldUpdateMixin from 'app/mixins/InputFieldUpdateMixin.js';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import EditorButtons from 'app/components/EditorComponents/EditorButtons.jsx';
import Utilities from 'app/utility/Utilities.js';
import * as _ from 'underscore';
import { Outlet } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class InputEdit extends React.Component {
	constructor(props) {
		super(props);

		let tab = 'settings',
			path = this.props.router.location.pathname;

		if (path.match(/status$/)) {
			tab = 'status';
		}

		this.state = {
			input: {},
			routeName: '',
			errors: null,
			currentTab: tab,
			credID: ''
		};

		this.save = this.save.bind(this);
		this.cancelAction = this.cancelAction.bind(this);

	}

	static getDerivedStateFromProps(props, state) {
		let nextState = {},
			input = null,
			defaultAttrs = {
				prefixText: '',
				prefixSpace: 0,
				postfixtText: '',
				postfixSpace: 0
			};

		if (props.app.firstLoad.ROUTE_LIST === true) {
			input = props.findInput(props.router.params.inputId, props);
			// if attrs are present we know we have the 'show' version of the input
			if (input !== null && input.attrs !== undefined) {
				if (_.isEmpty(state.input) || (parseInt(input.id, 10) !== parseInt(state.input.id, 10))) {
					nextState.input = Utilities.deepClone(input);
					if (_.isArray(nextState.input.attrs)) {
						nextState.input.attrs = _.clone(defaultAttrs);
					}
				}
				if (state.credID !== '') {
					input.credID = state.credID;
					nextState.credID = '';
				}
			}
		}

		return (Object.keys(nextState).length) ? nextState : null;

	}

	componentDidMount() {
		let inputId = this.props.router.params.inputId,
			routeId = this.props.router.params.routeId,
			state = (this.props.router.query !== null && this.props.router.query.state) ? this.props.router.query.state : '';

		if (this.props.app.firstLoad.ROUTE_LIST === false) {
			this.props.getRoutes();
		}

		if (inputId && this.props.app.firstLoad.ROUTE_LIST === true) {
			this.props.getInput(inputId);
		} else if (!inputId && !routeId) {
			this.props.router.navigate("/share/automate");
		}

	}

	componentDidUpdate(prevProps, prevState) {
		let errors = [],
			prevRoute = null,
			currentRoute = null,
			prevInput = null,
			currentInput = null;

		if (prevProps.app.firstLoad.ROUTE_LIST === false && this.props.app.firstLoad.ROUTE_LIST === true){
			this.props.getInput(this.props.router.params.inputId);
		}

		errors = this.props.getApiErrors(['INPUT_CREATE', 'INPUT_UPDATE', 'ROUTE_DELETE']);
		if (errors.length && this.state.errors === null) {
			let input = this.state.input;
			if (errors[0].errors !== undefined && errors[0].errors.perms !== undefined) {
				this.props.showUpgradeModal(this.props.closeAllModals, null, errors[0], 'input_error');
				input = this.props.findInput(this.props.router.params.inputId);
				input = _.clone(input);
			}
			this.setState({
				errors: errors[0],
				input
			});
		}

		prevRoute = this.props.findRoute(this.props.router.params.routeId, prevProps);
		currentRoute = this.props.findRoute(this.props.router.params.routeId);

		// Input was deleted!
		if (prevRoute !== null && currentRoute !== null && _.isArray(prevRoute.inputs) && _.isArray(currentRoute.inputs)) {
			if (prevRoute.inputs.length > currentRoute.inputs.length) {
				this.props.router.navigate("/share/automate");
			}
		}

		if (prevProps.app.loading.INPUT_SHOW === false && this.props.app.loading.INPUT_SHOW === true) {
			if (window.location.href.match(/REAUTHINPUT/)) {
				this.props.authReturnHandler({
					path: '/share/automate/detail/' + this.props.router.params.routeId + '/input/' + this.props.router.params.inputId + '/detail'
				}, (input) => {
					this.props.resetAuthState();
					input.routeId = this.props.router.params.routeId;
					this.props.updateInput(input);
					this.setState({
						credID: input.credID
					});
				});
			}
		}

		if (prevProps.app.loading.INPUT_UPDATE === true && this.props.app.loading.INPUT_UPDATE === false && errors.length === 0) {
			this.props.router.navigate("/share/automate/detail/" + this.props.router.params.routeId);
		}

		if (prevProps.app.loading.ROUTE_DELETE === true && this.props.app.loading.ROUTE_DELETE === false && errors.length === 0) {
			this.props.router.navigate("/share/automate");
		}

	}

	save() {
		let i = 0,
			schedsToSend = [],
			sched = {},
			rulesToSend = [],
			rule = '';

		// check for a new schedule which hasn't been set up
		// if no days have been selected, throw it away
		if (this.state.input.sched.length) {
			for (i = 0; i < this.state.input.sched.length; ++i) {
				sched = this.state.input.sched[i];
				if (sched.s_id.match !== undefined && sched.s_id.match('sch-') && sched.s_days === 0) {
					continue;
				}
				schedsToSend.push(sched);
			}
			this.state.input.sched = schedsToSend;
		}

		// clean up input rules. due to react assuming state is immutable and
		// rules being mutable, 'deleted' rules need to be hidden until the user hits 'save'
		if (this.state.input.rules.length) {
			for (i = 0; i < this.state.input.rules.length; ++i) {
				rule = this.state.input.rules[i];
				if (rule.deleted === undefined) {
					rulesToSend.push(rule);
				}
			}
			this.state.input.rules = rulesToSend;
		}

		// The error for required prefixes should already be showing, just ensure the
		// user can't save with no prefix
		if (this.state.input.attrs.repost && this.state.input.attrs.echoPrefix) {
			for (i = 0; i < this.state.input.attrs.repost.length; ++i) {
				if (this.state.input.attrs.echoPrefix[i] === undefined || this.state.input.attrs.echoPrefix[i] === '') {
					return;
				}
			}
		}

		this.props.updateInput(this.state.input);

	}

	cancelAction() {

		let routeId = this.props.router.params.routeId;

		this.props.router.navigate('/share/automate/detail/' + routeId);

	}

	render() {
		let constants = this.props.app.config.constants,
			EditHeader = null,
			MainPanel = null,
			routeId = this.props.router.params.routeId,
			inputId = this.props.router.params.inputId,
			buttons = InputEditorButtons.getButtons.apply(this, ['/share/automate/detail/' + routeId + '/input/' + inputId]),
			title = this.state.input.name ? this.state.input.name : '',
			buttonActive = false,
			buttonAction = null,
			textRuleHandler = (this.props.router.location.pathname.match('text')) ? InputFieldUpdateMixin.requestTextRuleChange.bind(this) : null,
			scheduleHandler = (this.props.router.location.pathname.match('update')) ? InputFieldUpdateMixin.requestScheduleChange.bind(this) : null,
			errorBlock = null,
			sectionTitle = "Your Feeds",
			currentTab = (this.props.router.location.pathname.match('status')) ? 'status' : 'settings',
			inputType = '',
			inputLabel = '',
			{ children, ...otherProps } = this.props;


		if (parseInt(this.props.app.flags.routeViewType, 10) === constants.ROUTE_VIEW_ADVANCED) {
			let route = this.props.findRoute(this.props.router.params.routeId);
			if (route !== null) {
				sectionTitle = route.name;
			}
		}

		EditHeader = (
			<EditInputHeader
			    {...this.props}
				section={sectionTitle}
				action={title}
				routeViewType={this.props.app.flags.routeViewType}
				activeTab={currentTab}
				inputType={this.state.input.type} />
		);

		let cleanInput = this.props.findInput(this.props.router.params.inputId);
		buttonActive = FormUtilityMixin.isObjectDirty(this.state.input, cleanInput);

		if (buttonActive) {
			buttonAction = this.save;
		}

		if (this.state.errors !== null) {
			errorBlock = (
				<div className="detail-status error">
					We couldn't complete that update. Check the highlighted tabs for details.
				</div>
			);
		}

		inputLabel = ConstantMixin.getInputServiceByCode(this.state.input.type);
		if (inputLabel !== 'Feed') {
			inputLabel += " Feed";
		}

		otherProps.input = this.state.input;
		otherProps.cleanInput = cleanInput;
		otherProps.changeHandler = FormUtilityMixin.requestChange.bind(this);
		otherProps.textRuleHandler = textRuleHandler;
		otherProps.scheduleHandler = scheduleHandler;
		otherProps.statePath = "input";
		otherProps.isDirty = FormUtilityMixin.isObjectDirty(this.state.input, cleanInput);

		if (currentTab === 'settings') {
			MainPanel = (
				<div>
					{errorBlock}
					<ButtonList buttons={buttons}
						wrapperClass="editor-tabs"
						linkClass="editor-tab-item"
						activeClass="tab-active"
						errorClass="tab-error" />
					<Outlet context={otherProps}/>
					<EditorButtons
						cancelAction={this.cancelAction}
						saveActive={buttonActive}
						saveAction={this.save}
						saveLabel="Save" />
				</div>
			);
		} else if (currentTab === 'status') {
			MainPanel = (
				<div>
					{errorBlock}
					<Outlet context={otherProps}/>
				</div>);
		} else {
			MainPanel = (
				<div>
					{errorBlock}
					<Outlet context={otherProps}/>
					<EditorButtons
	  					  cancelAction={this.cancelAction}
	  					  saveActive={buttonActive}
	  				      saveAction={this.save}
	  					  saveLabel="Save" />
				</div>
			);
		}

		return (
			<Content
				header={EditHeader}
				main={MainPanel} />
		);
	}

};

InputEdit.displayName = "InputEdit";

InputEdit.propTypes = {
	routeViewType: PropTypes.number,
	userPerms: PropTypes.object,
	recordPath: PropTypes.func,
	trialEligible: PropTypes.bool
};

InputEdit.defaultProps = {
	routeViewType: 0, // ROUTE_VIEW_ADVANCED
	userPerms: {},
	recordPath: () => {},
	trialEligible: false
};

export default ComponentWithContext(InputEdit);
